export enum RoutesUrl {
  Home = '/',
  Logout = '/logout',
  Library = '/library',
  Materials = '/materials',
  Backpack = '/backpack',
  Chat = '/chat',
  ChatRestart = '/chat/:restart?',
  Xpeditions = '/xpedition',
  Xpedition = '/xpedition/:xpeditionId/:restart?',
  Interventions = '/interventions',
  ProgramDetail = '/interventions/:apId',
  StepContent = '/interventions/:apId/steps/:stepId',
  Settings = '/settings',
  Content = '/content',
  PublicContent = '/public-content',
  Callback = '/callback',
  Dialogues = '/dialogues',
  Dialogue = '/dialogue/:dialogueId',
  Article = '/article/:articleId',
  ArticleAuthors = '/article/authors/:articleId',
  ReferenceAuthors = '/article/reference/authors/:articleId/:referenceId',
  ArticleReferences = '/article/references/:articleId',
  ArticleReference = '/article/reference/:articleId/:referenceId',
  ArticleSection = '/article/section/:articleId/:sectionIndex',
  ArticleSections = '/article/sections/:articleId',
  ArticleCollections = '/article/collections/:articleId',
  ArticleTableOfContents = '/article/tableofcontents/:articleId',
  ArticleTables = '/article/tables/:articleId',
  ArticleSummary = '/article/summary/:articleId',
  Resource = '/resource',
  Journals = '/journals',
  Journal = '/journal/:journalId',
  Reviews = '/reviews',
  Review = '/review/:reviewId',
  Chatroom = '/chatroom',
  ChatroomDialogue = '/chatroom/:dialogueId',
  CmResource = '/cmresource',
  DmResource = '/dmresource',
  ActivityJournals = '/activity-journals',
  CmResourceCard = '/cmresource/:srvId',
  Referrals = '/referrals',
  CmResourceOrganization = '/cmresource/org/:orgId',
  Search = '/search',
  SearchDialogue = '/search/:dialogueId',
  Trainings = '/trainings',
  TrainingsChat = '/trainings/:dialogueId',
  Exercise = '/exercise',
  ExerciseChat = '/exercise/:dialogueId',
  Statistics = '/statistics',
  AllStatistics = '/allstatistics',
  AccessDenied = '/access-denied',
  EmailNotVerified = '/email-not-verified',
  Sessions = '/sessions',
  SessionChat = '/session/:xpeditionId',
  Activities = '/activities',
  ActivityChat = '/activity/:xpeditionId',
  ActivityJournalChat = '/activity-journal/:xpeditionId',
  Notifications = '/notifications',
}

export enum TranslationKeys {
  Library = 'library',
  Materials = 'materials',
  Backpack = 'backpack',
  Chat = 'chat',
  Settings = 'user-settings',
  Content = 'content-page',
  Error = 'error',
  Footer = 'footer',
  Common = 'common',
  Home = 'home',
  Toasts = 'toasts',
  Dialogues = 'dialogues',
  Dialogue = 'dialogue',
  Article = 'article',
  Resource = 'resource',
  Journals = 'journals',
  Reviews = 'reviews',
  Chatroom = 'chatroom',
  CmResource = 'cmresource',
  Referrals = 'referrals',
  Search = 'search',
  Trainings = 'trainings',
  Exercise = 'exercise',
  Statistics = 'statistics',
  Sessions = 'sessions',
  Activities = 'activities',
  ActivityJournals = 'activity-journals',
  Notifications = 'notifications',
}

export const firstAuthorizedRoute = RoutesUrl.Chat;
export const userProfileRoute = RoutesUrl.Settings;

export const routeTranslationKeys: { [key: string]: string } = {
  [RoutesUrl.Library]: TranslationKeys.Library,
  [RoutesUrl.Materials]: TranslationKeys.Materials,
  [RoutesUrl.Backpack]: TranslationKeys.Backpack,
  [RoutesUrl.Chat]: TranslationKeys.Chat,
  [RoutesUrl.ChatRestart]: TranslationKeys.Chat,
  [RoutesUrl.Xpeditions]: TranslationKeys.Chat,
  [RoutesUrl.Xpedition]: TranslationKeys.Chat,
  [RoutesUrl.Interventions]: TranslationKeys.Chat,
  [RoutesUrl.Settings]: TranslationKeys.Settings,
  [RoutesUrl.Content]: TranslationKeys.Content,
  [RoutesUrl.Dialogues]: TranslationKeys.Dialogues,
  [RoutesUrl.Dialogue]: TranslationKeys.Dialogue,
  [RoutesUrl.Resource]: TranslationKeys.Resource,
  [RoutesUrl.Journals]: TranslationKeys.Journals,
  [RoutesUrl.Reviews]: TranslationKeys.Reviews,
  [RoutesUrl.Chatroom]: TranslationKeys.Chatroom,
  [RoutesUrl.ChatroomDialogue]: TranslationKeys.Chatroom,
  [RoutesUrl.CmResource]: TranslationKeys.CmResource,
  [RoutesUrl.DmResource]: TranslationKeys.CmResource,
  [RoutesUrl.Referrals]: TranslationKeys.Referrals,
  [RoutesUrl.Search]: TranslationKeys.Search,
  [RoutesUrl.Trainings]: TranslationKeys.Trainings,
  [RoutesUrl.Exercise]: TranslationKeys.Exercise,
  [RoutesUrl.Statistics]: TranslationKeys.Statistics,
  [RoutesUrl.AllStatistics]: TranslationKeys.Statistics,
  [RoutesUrl.Sessions]: TranslationKeys.Sessions,
  [RoutesUrl.Activities]: TranslationKeys.Activities
};

export enum Pages {
  Library = 'library',
  Share = 'share',
  Backpack = 'backpack',
  Chat = 'chat',
  Xpedition = 'xpedition',
  Intervention = 'intervention',
  Settings = 'user-settings',
  Dialogues = 'dialogues',
  Resource = 'resource',
  Journals = 'journals',
  Reviews = 'reviews',
  Chatroom = 'chatroom',
  CmResource = 'cmresource',
  DmResource = 'dmresource',
  Referrals = 'referrals',
  Search = 'search',
  Trainings = 'trainings',
  Exercises = 'exercises',
  Statistics = 'statistics',
  AllStatistics = 'allstatistics',
  Content = 'content',
  Sessions = 'sessions',
  Activities = 'activities',
  ActivityJournals = 'activity-journals',
}
